import React from 'react';
import {SectionHeader} from "./SectionHeader";
import {SectionDescription} from "./SectionDescription";

export const AboutMeScreen = () => {
    return (
            <div className='about-me-screen'>
                <SectionHeader sectionName={'ABOUT ME'}/>
                <SectionDescription description={'I am a software Engineer specialized in building high quality ' +
                'web applications. I have extensive experience with React, Redux, JAVA and Springboot. ' +
                'I am passionate about creating products which makes life easier and effective.'}/>
            </div>
    );
}